import moment from 'moment';

import * as Time from './timeConstants';

export const isValueInRange = (x, min, max) => x >= min && x <= max;
export const isAllowedDate = (birthday, checkedPeriod, maxAllowed) => maxAllowed > checkedPeriod - birthday;
export const parseInputToDate = (input) => {
  if (input && input.length === Time.DATE_LENGTH_WITHOUT_SPECIAL_CHARS) {
    input.toString().replace(/(\d{2})/g, '$1 ')
      .replace(/(^\s+|\s+$)/, '-');
  }
  return (input ? new Date(input.toString().replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3')) : new Date());
};
export const isPercentOverMaxValue = (a, b, maxValue) => (a / b) * 100 > maxValue;
export const passDigitsOnlyOnKeyPress = (event, isMinusEnable) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);
  const justDigits = /^\d*\d*$/;
  const digitsWithMinus = /^[-]?\d*\d*$/;
  if (!(isMinusEnable ? digitsWithMinus : justDigits).test(keyValue)) {
    event.preventDefault();
  }
};
export const calculateInsuranceEndDate = (birthday) => {
  const RETIREMENT_AGE = 67;
  const retirementAgeDate = moment(birthday, Time.DD_MM_YYYY).add(RETIREMENT_AGE, Time.YEARS);
  return retirementAgeDate.subtract(1, Time.MONTHS).endOf(Time.MONTH);
};

export const isAfterLastDayOfMonth = (date) => (moment(date, Time.DD_MM_YYYY)
  .endOf(Time.MONTH)
  .isAfter(moment(date, Time.DD_MM_YYYY), Time.DAY));

export function scrollToBottom() {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth',
  });
}
